export type BillLineItemFormValue = {
  durian_type?: string
  grade?: string
  weight_kg: number
  price_per_kg: number
  description?: string
  box_count?: number
  weight_per_box_kg?: number
  strap_band?: string
  strap_quantity?: number
}

export const emptyLineItem = (): BillLineItemFormValue => ({
  durian_type: '',
  grade: '',
  weight_kg: 0,
  price_per_kg: 0,
  description: '',
  box_count: 0,
  weight_per_box_kg: 0,
  strap_band: '',
  strap_quantity: 0,
})

export function isLineItemFilled(row?: BillLineItemFormValue | null): boolean {
  if (!row) return false
  return Boolean(
    row.durian_type?.trim() ||
      row.grade?.trim() ||
      row.description?.trim() ||
      row.strap_band?.trim() ||
      Number(row.weight_kg) > 0 ||
      Number(row.price_per_kg) > 0 ||
      Number(row.box_count) > 0 ||
      Number(row.weight_per_box_kg) > 0 ||
      Number(row.strap_quantity) > 0,
  )
}

export function filterFilledLineItems<T extends BillLineItemFormValue>(rows: T[]): T[] {
  return rows.filter((row) => isLineItemFilled(row))
}

export type BillExtraChargeFormValue = {
  expense_type_name?: string
  quantity?: number
  unit_price_baht?: number
}

export const emptyExtraCharge = (): BillExtraChargeFormValue => ({
  expense_type_name: '',
  quantity: 0,
  unit_price_baht: 0,
})

export function isExtraChargeFilled(row?: BillExtraChargeFormValue | null): boolean {
  if (!row) return false
  return Boolean(
    row.expense_type_name?.trim() ||
      Number(row.quantity) > 0 ||
      Number(row.unit_price_baht) > 0,
  )
}

export function filterFilledExtraCharges<T extends BillExtraChargeFormValue>(rows: T[]): T[] {
  return rows.filter((row) => isExtraChargeFilled(row))
}

export function extraChargeRowAmount(row: { quantity?: number; unit_price_baht?: number }) {
  const qty = Number(row.quantity)
  const price = Number(row.unit_price_baht)
  if (qty >= 1 && price > 0) {
    return Math.round(qty * price * 100) / 100
  }
  return 0
}
